import { Dispatch } from 'redux';

import { apiFetchAreasOfFocus } from 'api/apiAreaOfFocus';
import { ApiAreaOfFocus } from 'api/types/ApiAreaOfFocus';

import { setError } from './error';

export type MainStoreAreasOfFocusState = ApiAreaOfFocus[] | null | undefined;

// Types

export type MainStoreAreasOfFocusAction = {
  type: 'AREAS_OF_FOCUS_SET';
  areasOfFocus: ApiAreaOfFocus[] | null | undefined;
};

// Reducer

export function areasOfFocusReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: MainStoreAreasOfFocusState = null,
  action: MainStoreAreasOfFocusAction,
) {
  switch (action.type) {
    case 'AREAS_OF_FOCUS_SET': {
      return action.areasOfFocus;
    }

    default:
      return state;
  }
}

// Actions

export const fetchAreasOfFocus =
  () =>
  (
    dispatch: Dispatch<MainStoreAreasOfFocusAction>,
    getState: () => { areasOfFocus: ApiAreaOfFocus[] },
  ) => {
    if (getState().areasOfFocus) {
      return;
    }

    apiFetchAreasOfFocus()
      .then((areasOfFocus) => {
        dispatch({
          type: 'AREAS_OF_FOCUS_SET',
          areasOfFocus,
        });
      })
      .catch(setError);
  };
